import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, TrendingUp, ChevronRight, Search } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileSalesOrdersPage() {
  const navigate = useNavigate();
  const [sos, setSos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get(`${API}/warehouse/sales-orders`).then(r => setSos(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = sos.filter(s => !search || (s.so_number || '').toLowerCase().includes(search.toLowerCase()) || (s.customer_name || '').toLowerCase().includes(search.toLowerCase()));

  if (loading) return <div className="mobile-page"><div className="mobile-loading"><div className="mobile-spinner" /></div></div>;

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/more')}><ArrowLeft size={18} /> More</button>
      <div className="mobile-page-title" style={{ marginBottom: 12 }}>Sales Orders</div>
      <div style={{ position: 'relative', marginBottom: 14 }}>
        <Search size={16} style={{ position: 'absolute', left: 12, top: 13, color: '#8e8e93' }} />
        <input className="mobile-input" placeholder="Search SOs..." value={search} onChange={e => setSearch(e.target.value)} style={{ paddingLeft: 36 }} />
      </div>
      <div className="mobile-kpi-row" style={{ marginBottom: 14 }}>
        <div className="mobile-kpi-card blue"><div className="mobile-kpi-label">Total SOs</div><div className="mobile-kpi-value">{sos.length}</div></div>
        <div className="mobile-kpi-card green"><div className="mobile-kpi-label">Open</div><div className="mobile-kpi-value">{sos.filter(s => s.status === 'open' || s.status === 'pending' || s.status === 'confirmed').length}</div></div>
      </div>
      {filtered.length === 0 ? <div className="mobile-empty-state"><TrendingUp /><p>No sales orders found</p></div> : (
        <div className="mobile-menu-list">
          {filtered.map(so => (
            <button key={so.so_id} className="mobile-menu-item" onClick={() => navigate(`/mobile/sales-orders/${so.so_id}`)}>
              <div className="mobile-menu-item-icon" style={{ background: so.status === 'shipped' ? '#34c759' : '#007aff' }}><TrendingUp size={16} /></div>
              <div className="mobile-menu-item-content">
                <div className="mobile-menu-item-title">{so.so_number}</div>
                <div className="mobile-menu-item-subtitle">{so.customer_name || 'N/A'} · {so.status || 'open'} · {so.line_items?.length || 0} items</div>
              </div>
              <ChevronRight size={16} className="mobile-menu-item-chevron" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
